import React from 'react';
import { UnifiedApprovalHub } from '../components/unified-approval-hub';

export default function UnifiedApprovalHubPage() {
  return <UnifiedApprovalHub />;
}
